import { useCallback, useState } from "react";
import {
  DEFAULT_FAVOURITES,
  FAVOURITES_STORAGE,
} from "./constants";
import type { ActionId } from "./types";

const loadFavourites = (): ActionId[] => {
  try {
    const stored = localStorage.getItem(FAVOURITES_STORAGE);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed as ActionId[];
      }
    }
  } catch (e) {
    // ignore parse errors
  }
  return [...DEFAULT_FAVOURITES];
};

export function useFavourites() {
  const [favourites, setFavourites] = useState<ActionId[]>(loadFavourites);

  const save = useCallback((newFavs: ActionId[]) => {
    setFavourites(newFavs);
    try {
      localStorage.setItem(FAVOURITES_STORAGE, JSON.stringify(newFavs));
    } catch (e) {
      // ignore storage errors
    }
  }, []);

  return { favourites, save };
}